import { Directive, Input } from '@angular/core';
import { IAccountBalance } from '../../models/masterdata/account-balance.model';

@Directive()
export abstract class AccountBalanceBaseComponent {
  @Input() accountBalance: IAccountBalance;
}
